<template>
  <v-layout column class="notification-container">
    <div class="notification-group">
      <div class="notification-group-title">
        Visitor notifications
      </div>
      <div class="notifications-container">
        <div class="notification">
          <div class="notification-text">
            <div class="name">Event Cancellation Notification</div>
            <div class="desc">Notify me if the event is canceled and provide information about refunds.</div>
          </div>
          <div class="switch">
            <label class="notification-switch">
              <input type="checkbox" v-model="notifications.eventCancelNotification"/>
              <span class="notification-slider round"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="userVerified" class="notification-group">
      <div class="notification-group-title">
        Organiser notifications
      </div>
      <div class="notifications-container">
        <div class="notification" v-for="notification in organizationNotifications" :key="notification.type">
          <div class="notification-text">
            <div class="name">{{ notification.name }}</div>
            <div class="desc">{{ notification.description }}</div>
          </div>
          <div class="switch">
            <label class="notification-switch">
              <input type="checkbox" v-model="notifications[notification.type]"/>
              <span class="notification-slider round"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'user-profile',
  props: {
    notificationData: {
      type: Object,
      default: {}
    },
    userVerified: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      notifications: this.notificationData,
      organizationNotifications: [
        { name: 'Ticket sale', description: 'Notify me whenever a ticket is sold.', type: 'ticketSaleNotification'},
        { name: '50% of each ticket type sold', description: 'Notify me when 50% of each ticket type for the event is sold.', type: 'halfTicketsSoldNotification'},
        { name: 'Sale ends', description: 'Notify me of unsold tickets for each type one day before sales end.', type: 'unsoldTicketsNotification'},
        { name: 'Low ticket availability', description: 'Notify me if less than 10% of the total tickets are left for sale.', type: 'lowAvailabilityNotification'},
        { name: 'Sold out', description: 'Notify me when a ticket type is sold out.', type: 'ticketsSoldOutNotification'},
        { name: 'Long Idle Period Notification', description: 'Notify me if the availability date of a ticket is significantly earlier than the event date.', type: 'longIdlePeriodNotification'},
      ]
    }
  },
}
</script>

<style scoped>
.notification-container {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 2rem;
  gap: 32px;
}
.notification-group {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
}
.notification-group-title {
  align-self: stretch;
  color: #0277BD;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.6px;
}
.notifications-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: start;
  width: 100%;
}
.notification {
  display: flex;
  width: 100%;
  padding: 8px 0;
  align-items: flex-start;
  gap: 24px;
  border-bottom: 1px solid #F5F5F5;
}
.notification-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: center;
}
.notification-text .name {
  align-self: stretch;
  color: #333;
  font-family: "Source Sans Pro";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.notification-text .desc {
  align-self: stretch;
  color: #666;
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.switch {
  height: 68px;
  align-content: center;
}
.notification-switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 32px;
}
.notification-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.notification-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  border: 2px solid #979797;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.notification-slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 6px;
  bottom: 6px;
  background-color: #979797;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .notification-slider {
  background-color: #0277BD;
  border: none;
}
input:focus + .notification-slider {
  box-shadow: 0 0 1px #0277BD;
}
input:checked + .notification-slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
  background-color: white;
  height: 24px;
  width: 24px;
  left: 6px;
  bottom: 4px;
}
.notification-slider.round {
  border-radius: 34px;
}
.notification-slider.round:before {
  border-radius: 50%;
}
</style>
